<section class="menu-card text-xs font-medium tracking-tight shadow-lg">
  <article
    class="flex w-full flex-col rounded-2xl bg-gradient-to-b from-white to-[#E9E3FF] px-3.5 pb-5 pt-2.5"
  >
    <svg-icon
      src="assets/svg/pin-info.svg"
      class="aspect-square w-4 cursor-pointer self-end"
      (click)="openModal()"
    ></svg-icon>

    <img
      loading="lazy"
      src="assets/rush/5K-gold-coins-in-pot.png"
      alt="Table illustration"
      class="h-[140x] w-[140px] self-center"
    />

    <div class="flex flex-col rounded-2xl">
      <h2 class="text-base font-bold leading-5 text-black">{{ table.name }}</h2>
      <div class="inline-flex items-center gap-1 text-lg font-black text-[#f9a32c]">
        <div>POT: {{ table.potBonus | number: '1.0-2' }}</div>
      </div>
      <div class="mt-2 grid gap-1 text-[10px]">
        <div
          class="mb-[0.3rem] inline-flex items-center justify-center gap-1 rounded-full bg-[#CCC7D9] px-2 py-1 font-bold text-black"
        >
          {{ table.buyInCost | number: '0.0-2' }} Coins Buy In
        </div>
        <div
          class="mb-[0.3rem] inline-flex items-center justify-center gap-1 rounded-full bg-[#CCC7D9] px-2 py-1 font-bold text-black"
        >
          {{ table.foldCost | number: '0.0-2' }} FOLD
        </div>
        <div
          class="mb-[0.3rem] inline-flex items-center justify-center gap-1 rounded-full bg-[#CCC7D9] px-2 py-1 font-bold text-black"
        >
          <div>{{ table.minBet | number: '0.0-2' }} - {{ table.maxBet | number: '0.0-2' }} BET</div>
        </div>
        <div
          class="mb-[0.3rem] inline-flex items-center justify-center gap-1 rounded-full bg-[#CCC7D9] px-2 py-1 font-bold text-black"
        >
          <div>5 SEATS</div>
        </div>
      </div>
      <button
        *ngIf="!isLoggerPage"
        (click)="goToGameRoom()"
        [disabled]="!table.active"
        class="mt-6 flex flex-row items-center justify-center rounded-lg bg-black px-9 py-2.5 font-bold leading-[180%] text-white"
      >
        PLAY
        <svg-icon
          loading="lazy"
          src="assets/rush/svg/icon-play.svg"
          alt="play"
          class="mb-0.5 ml-2 h-[12x] w-[12px]"
        />
      </button>
      <button
        *ngIf="isLoggerPage"
        (click)="onClickLoggerPage(mainDealer.id)"
        class="mt-6 justify-center whitespace-nowrap rounded-lg bg-black px-9 py-2.5 text-center font-bold leading-[180%] text-white"
      >
        SELECT
      </button>
    </div>
  </article>
</section>
